import React, { ReactNode } from "react";
import Tag from "../../../../../generic/tag";
import "../../../../../../assets/scss/components/toc/orderBook/instruments/instrumentsMob.scss";
import { ChipColorKeyComb, scrlStCls, ObScrollStyle } from "../../../obConstants";
import { IIpo } from "../../../../../types/components/orderBook/obTypes";
import { HObGroupBy } from "../../../../../service/orderBook/obGrpByHelper";
import ObAssetDetailPopup from "../../../generic/obAssetDetailPopup";
import ObIpoDtlsMob from "../../../obDetails/mob/obIpoDtlsMob";
import { ChipStatusComb } from "./../../../obConstants";
import dateTimeFormat from "../../../../../service/dateTimeService";
import bStrg from "../../../../../service/storageHelper";
import { AIpoCancelTrd } from "../../../../../service/orderBook/obApiService";
import ee from "../../../../../utils/eventEmitter";
import ObUtilHeader from "../../../obContainer/obUtilHeader";
import { SearchHighLight } from "../../../../../service/generic/searchHighlight";

export interface IOnIpoMobProps {
	data: Array<any>;
	isHistory: boolean;
	noDataNode: ReactNode;
	reRenderCall?: (value: string) => void;
	hidePageNav?: (hide: boolean) => void;
}

const OnIpoMob: React.FC<IOnIpoMobProps> = (props) => {
	for (let i = 0; i < props.data.length; i++) {
		let element: IIpo = props.data[i];
		element["sts"] = element.mwStatus.split("-").length !== 1 ? element.mwStatus.split("-")[1].trim() : element.mwStatus.split(" ")[1].trim();
		element["sts"] = element["sts"].toLowerCase();
	}
	// initial data is array of array for supporting grouping

	const initialData = [JSON.parse(JSON.stringify(props.data))],
		todayDate = bStrg("todayDate") || new Date();
	let [tableData, setTableData] = React.useState(initialData);

	let ipoData: Array<{ [x: string]: Array<IIpo> }> | null = null;

	React.useEffect(() => {
		setTableData([props.data]);
	}, [props.data, props.isHistory]);

	if (props.data) {
		//group data based on biddingEndDate
		let results = tableData.map((group) =>
			group.reduce(
				(arr: any, d: IIpo) => {
					if (dateTimeFormat(d.biddingEndDate, "-").setHours(0, 0, 0) >= new Date(todayDate).setHours(0, 0, 0) && d.biddingEndDate) {
						arr[0] = [...arr[0], d];
					} else {
						arr[1] = [...arr[1], d];
					}
					return arr;
				},
				[[], []]
			)
		);

		ipoData =
			tableData.length > 0 && results[0][!props.isHistory ? 0 : 1].length > 0
				? [HObGroupBy(results[0][!props.isHistory ? 0 : 1], "submitDt", ",")]
				: null;
	}
	//after applying filters following method will invoked to show the updated results
	function onDataFilter(data: Array<any>, sText: string = "", type?: string) {
		//highlightes the search text
		if (sText) {
			const SearchText: string = sText.toLowerCase();
			data[0].forEach((ord: IIpo) => {
				ord.ipoNm = SearchHighLight(ord.ipoNm, SearchText);
			});
		}
		setTableData(data);
	}
	//is popup data
	const [popupDataIndex, setPopupDataIndex] = React.useState<[string, number]>();

	// this function excute on clicking any row
	function onRowClick(data: any, groupIndex: string, index: number, e?: any) {
		if (e.target.tagName !== "LI") {
			// getOrderLogs(data.ordID);
			setPopupDataIndex([groupIndex, index]);
		}
	}

	let ordCancelledSuccList: Array<string> = [],
		ordCancelledFailList: Array<string> = [],
		ordsListToCancel: Array<string> = [];

	// runs after all cancel api response
	function cancelCallback(res: any) {
		if (res.data) {
			// if success
			ordCancelledSuccList.push(res.data);
		} else {
			// if error
			ordCancelledFailList.push(res.error);
		}

		// when we get all the responses
		if (ordCancelledSuccList.length + ordCancelledFailList.length === ordsListToCancel.length) {
			//show toast message
			ee.emit("showToast", { message: `Cancelled ${ordsListToCancel.length} Orders`, color: "cancell" });
			props.reRenderCall && props.reRenderCall("today");
		}
	}

	function cancelOrder(data: any) {
		ordsListToCancel.push(data.ordID);
		AIpoCancelTrd(cancelCallback, data.ordID);
	}

	function ipoRw(data: IIpo, groupIndex: string, index: number) {
		return (
			<div className="ipo_mob new_offers_mob_con" key={index}>
				<div className="tag">
					<Tag value="B" shape="mini_circle" color="green" height="30px" width="30px" />
				</div>
				<div className="new_offers_data" onClick={(e) => onRowClick(data, groupIndex, index, e)}>
					<div className="date">{data.submitDt.split(",")[1].replace(/am|pm/gi, ":00").replace(/\s/gi, "")}</div>
					<div className="comp_con">
						<div className="sym">
							<span dangerouslySetInnerHTML={{ __html: data.ipoNm }}></span>
						</div>
						<div className="sts">
							<Tag value={ChipStatusComb[data.sts.toLowerCase()]} color={ChipColorKeyComb[data.sts]} />
						</div>
					</div>
					<div className="new_offers_values">
						<div className="prod_value">
							<span>{data.bids.length} bids</span> (
							<span>
								{data.bids.length !== 0 &&
									data.bids
										.map((el) => el.quantity)
										.reduce((accumulator, currentValue) => {
											return accumulator + currentValue;
										})}
								{data.bids.length === 0 && data.bids.length}{" "}
							</span>
							Qty)
						</div>
					</div>
				</div>
			</div>
		);
	}
	return (
		<>
			<ObUtilHeader
				leftSideText={
					ipoData ? (
						<div className="executed">
							<span className="text">Executed Orders: </span>
							<span className="value">
								{ipoData.map((g) =>
									Object.keys(g)
										.map((date) => g[date].filter((rw: IIpo) => rw.applicationNumber !== "").length)
										.reduce((acc, cv) => {
											return acc + cv;
										})
								)}
								/
								{ipoData &&
									Object.keys(ipoData[0])
										.map((key: string) => (ipoData ? ipoData[0][key].length : 0))
										.reduce((acc, cv) => {
											return acc + cv;
										})}
							</span>
						</div>
					) : (
						<></>
					)
				}
				data={(ipoData && Object.keys(ipoData).length) || !tableData[0] ? initialData : [[]]}
				searchKey="ipoNm"
				onDataFilter={onDataFilter}
				onSelectClick={undefined}
				onFilterClick={() => {}}
				filterReqData={{
					status: "sts",
					aType: "ipo",
					showOpenOrderOnTop: false,
					showOpenOrderTgl: false,
					isHistory: props.isHistory ? true : false
				}}
				onSearchClick={(e) => {
					// if exists, then call it
					// props.hidePageNav && props.hidePageNav(e);
				}}
			/>
			<div className={props.data.length > 0 ? "ObScrollCont" : ""} style={ObScrollStyle(props.data.length > 0 ? true : false)}>
				{ipoData &&
					ipoData.map((group, groupIndex) =>
						Object.keys(group).map((date, index) => {
							return (
								<React.Fragment key={index}>
									{/* if history componenet need to show*/}

									<ul className={scrlStCls.freeze + " eq_hist_date hist_date"} key={"dtGp" + index}>
										<li>{date.split(",")[0]}</li>
									</ul>
									<div className={scrlStCls.toContext} key={"dtUlDet" + index}>
										{group[date].map((row: any, index: number) => ipoRw(row, date, index))}
									</div>
								</React.Fragment>
							);
						})
					)}
			</div>
			{popupDataIndex && ipoData && (
				<ObAssetDetailPopup>
					<ObIpoDtlsMob
						data={ipoData[0][popupDataIndex[0]][popupDataIndex[1]]}
						onBackClick={() => setPopupDataIndex(undefined)}
						onCancelClick={() => cancelOrder(ipoData !== null && ipoData[0][popupDataIndex[0]][popupDataIndex[1]])}
					/>
				</ObAssetDetailPopup>
			)}
			{ipoData === null && props.noDataNode}
		</>
	);
};

export default OnIpoMob;
